export default __webpack_public_path__ + "static/media/assets-icon.026344a8.svg";